import { Flex, Tag } from 'antd'

import { renameTemplateApi } from '@eastcoal/api/contract/template/renameTemplate'

import { EditableInput } from '@eastcoal/common/components/EditableInput'
import { EditableInputProps } from '@eastcoal/common/components/EditableInput/interface'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { BasicProps } from '@eastcoal/common/types/component'
import { pick } from '@eastcoal/common/utils/object'

import { getTemplateName } from '../../../utils/getTemplateName'
import { useContractDesignerStore } from '../../Store/hooks/useStore'

const getPreviewComponent: EditableInputProps<string>['getPreviewComponent'] =
  ({ value }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { formData } = useContractDesignerStore(state =>
      pick(state, ['formData'])
    )
    return (
      <Flex align='center' gap={4}>
        <span>{getTemplateName(value)}</span>
        {formData.enable === false && <Tag color='red'>已停用</Tag>}
      </Flex>
    )
  }

export const TemplateNameInput = (props: BasicProps) => {
  const { message } = useFeedback()
  const {
    formData: { id, name },
    setTemplateName
  } = useContractDesignerStore(state =>
    pick(state, ['formData', 'setTemplateName'])
  )

  const handleChange = async (name?: string) => {
    if (!name) {
      return
    }
    setTemplateName(name)
    if (id) {
      await renameTemplateApi({
        id,
        name
      })
      message.success('模板名称修改成功', 1)
    }
  }

  return (
    <EditableInput
      {...props}
      getPreviewComponent={getPreviewComponent}
      value={name}
      onConfirm={handleChange}
    />
  )
}
